import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, user, loading, canAccessAdminPortal } = useAuth();

  // Wait for auth state to load before making redirect decision
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }

  // SECURITY: Must be authenticated AND have admin portal access
  // This prevents portal customers from accessing admin routes
  if (!isAuthenticated || !user) {
    // Clear stale localStorage to prevent Login.tsx from bouncing back here
    localStorage.removeItem('rbf_user_data');
    localStorage.removeItem('user');
    console.log('[ProtectedRoute] Not authenticated - redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  // Check if user has permission to access admin portal
  if (!canAccessAdminPortal) {
    console.log('[ProtectedRoute] User lacks admin portal access - access denied');
    // Redirect non-admin users to portal login or show access denied
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
        padding: '2rem'
      }}>
        <h1 style={{ color: '#dc2626', marginBottom: '1rem' }}>Access Denied</h1>
        <p style={{ marginBottom: '1rem' }}>You do not have permission to access the admin portal.</p>
        <p style={{ color: '#666' }}>
          If you're a customer, please use the{' '}
          <a href="/portal/login" style={{ color: '#2D5A27' }}>Customer Portal</a>.
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
